import { render, staticRenderFns } from "./OrganizationRegistrationWizard.vue?vue&type=template&id=3b14d88e&"
import script from "./OrganizationRegistrationWizard.vue?vue&type=script&lang=js&"
export * from "./OrganizationRegistrationWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports